import { LabelType } from 'v2/core/entities/taxonomy';
import { TRACKED_KEYWORD } from '../constants';

export function getDisplayNameForLabelType(labelType: LabelType) {
  switch (labelType) {
    case LabelType.L1:
      return 'Domain';

    case LabelType.Aspect:
      return TRACKED_KEYWORD;

    case LabelType.Reason:
      return 'Reason';
  }
}
